<template>
  <Drawer v-model="showDrawer" title="教师考勤明细" width="80">
    <div class="edu-home content-430">
      <div class="header-wrapper-430">
        <div class="table-title-special-430">
          <span class="box-title-430">{{ routeTitle }}</span>
          <div class="btn_wrap">
            <Button
              class="back"
              type="primary"
              :disabled="!schoolId"
              @click="exportHandel"
            >导出</Button>
          </div>
        </div>
      </div>
      <div class="table">
        <Table
          ref="selection"
          border
          :max-height="tableHeight - 40"
          :columns="columns12"
          :data="data"
          :loading="tableLoading"
        >
          <template slot="classroomName" slot-scope="{ row }">
            <TablePoptip :content="row.classroomName"> </TablePoptip>
          </template>
          <template slot="schoolName" slot-scope="{ row }">
            <TablePoptip :content="row.schoolName"> </TablePoptip>
          </template>
          <template slot="orgName" slot-scope="{ row }">
            <TablePoptip :content="row.orgName"> </TablePoptip>
          </template>
          <template slot="courseName" slot-scope="{ row }">
            <TablePoptip :content="row.courseName"> </TablePoptip>
          </template>

          <template slot="classTimeBegin" slot-scope="{ row }">
            <span> {{ row.classTimeBegin.slice(0, 10) }}</span>
          </template>
          <!-- 0未开始1未考勤2签到3签退4请假5缺席6停课 -->
          <template slot="signTime" slot-scope="{ row }">
            <span
              v-if="row.signState == 2 || row.signState == 3 || row.signTime"
            >{{ row.signTime }}</span>
            <span v-else>未签到</span>
          </template>
          <template slot="signoutTime" slot-scope="{ row }">
            <span v-if="row.signState == 3 || row.signoutTime">{{
              row.signoutTime
            }}</span>
            <span v-else>未签退</span>
          </template>
          <template slot="signPhotoIds" slot-scope="{ row }">
            <span
              v-if="row.signPhotoIds"
              class="color-blue cursor-pointer"
              @click="handleReview(row.signPhotoIds)"
            >
              查看图片
            </span>
            <span v-else>--</span>
          </template>
          <template slot="reSignState" slot-scope="{ row }">
            <span v-if="row.reSignState == 1"> 是 </span>
            <span v-else>--</span>
          </template>

          <template slot="classNo" slot-scope="{ row }">
            <span v-if="row.classNo != ''">
              第 {{ row.classNo }} 节课 ({{ row.classTimeBegin.slice(11, 16) }}-{{
                row.classTimeEnd.slice(11, 16)
              }})</span>
          </template>
          <template slot="temperature" slot-scope="{ row }">
            <span v-if="row.temperature != ''">{{ row.temperature }} °C</span>
          </template>
          <template slot="action" slot-scope="{ row, index }">
            <!-- <div v-if="portOrg == 0"> -->
            <span
              v-if="row.signState == 2 || row.signState == 3 || row.signTime"
              style="margin-right: 5px; color: #488ffa; cursor: pointer"
              @click="handleDelete(row)"
            >删除考勤记录</span>
            <span
              v-else
              style="margin-right: 5px; color: #488ffa; cursor: pointer"
              @click="handleBtn('set', row)"
            >补签</span>
          </template>
        </Table>
        <div class="page-wrap">
          <Page
            :total="pageInfo.count"
            show-total
            show-elevator
            show-sizer
            :page-size-opts="pageSizeOpts"
            :current="pageInfo.page"
            :page-size="pageInfo.size"
            @on-change="handlePageChange"
            @on-page-size-change="handleSizeChange"
          ></Page>
        </div>
      </div>

      <!-- 设置签到/签退时间 -->
      <Modal
        v-model="modal"
        :mask-closable="false"
        title="设置"
        :loading="loading"
      >
        <div class="page_modal">
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="150"
          >
            <FormItem label="姓名：" prop="newpassword">
              <div>{{ formValidate.teacherName }}</div>
            </FormItem>
            <FormItem label="课程名称：" prop="newpassword">
              <div>{{ formValidate.classroomName }}</div>
            </FormItem>
            <FormItem label="日期：" prop="newpassword">
              <div>{{ formValidate.classTimeBegin }}</div>
            </FormItem>
            <FormItem label="节次/时间：" prop="newpassword">
              <div>{{ formValidate.classNo }}</div>
            </FormItem>
            <FormItem class="form-require" label="签到时间：" prop="signTime">
              <DatePicker
                type="datetime"
                :value="formValidate.signTime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="签到时间"
                style="width: 200px"
                transfer
                @on-change="onSettimeChange"
              ></DatePicker>
            </FormItem>
            <FormItem label="签退时间：" prop="signoutTime">
              <DatePicker
                type="datetime"
                transfer
                :value="formValidate.signoutTime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="签退时间"
                style="width: 200px"
                @on-change="onendSettimeChange"
              ></DatePicker>
            </FormItem>
            <FormItem label="体温信息：" prop="password">
              <Input
                v-model="formValidate.temperature"
                style="width: 200px"
                placeholder="请输入体温"
              ></Input>
            </FormItem>
          </Form>
        </div>
        <div slot="footer">
          <Button
            type="text"
            @click="handleMageCancel('formValidate')"
          >取消</Button>
          <Button
            type="primary"
            @click="handleMageOK('formValidate')"
          >确定</Button>
        </div>
      </Modal>
      <ReviewPhoto ref="reviewPhotoRef" :img-list="imgList"></ReviewPhoto>
    </div>
  </Drawer>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { filterParams, downloadReport } from '@/utils/utils';
import EduCenterApi from '@/request/eduCenter';
import { tableColumnsWidth, key, slot, renderFn } from '@/assets/js/resetTableStyle';
import ReviewPhoto from '@/components/ReviewPhoto.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { getTodayDate } from '@/utils/moment.js';
export default {
  name: 'SignTeacherIndex',
  components: {
    ReviewPhoto
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      msg: '教师考勤',
      formValidate: {},
      pageSizeOpts: [10, 20, 50, 100],
      ruleValidate: {
      },
      loading: '',
      tableLoading: false,
      teacherList: [],
      showAllSearch: false,
      columns12: [
        slot('学校', 'schoolName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),

        key('教师姓名', 'teacherName', tableColumnsWidth.type8, {
          fixed: 'left'
        }),
        key('学期', 'termName', tableColumnsWidth.type4),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6),

        slot('节次/时间', 'classNo', tableColumnsWidth.type4),
        slot('日期', 'classTimeBegin', tableColumnsWidth.type9),
        slot('是否补签', 'reSignState', tableColumnsWidth.type2, {
          align: 'center'
        }),
        slot('签到时间', 'signTime', tableColumnsWidth.type4),
        slot('签退时间', 'signoutTime', tableColumnsWidth.type4),
        slot('体温', 'temperature', tableColumnsWidth.type2),
        slot('图片', 'signPhotoIds', tableColumnsWidth.type2),
        slot('课程商品名称', 'courseName', tableColumnsWidth.type6),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        slot('操作', 'action', tableColumnsWidth.type3, { fixed: 'right' })
      ],
      modal: false,
      data: [],
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      signId: '', // 签到id
      classroomId: '',
      imgList: [],
      schoolId: '',
      portOrg: localStorage.getItem('portOrg'),
      showDrawer: false,
      searchData: {}
    };
  },
  computed: { ...mapState(['userInfo', 'theUserIdentity', 'schoolIdForState']), ...mapGetters(['routeTitle']) },
  methods: {
    openDrawer(schoolId, searchData) {
      this.schoolId = schoolId;
      this.searchData = searchData;
      this.handleSearch();
      this.showDrawer = true;
    },

    // 查看考勤图片
    handleReview(fileIds) {
      const ids = fileIds.split(',');
      this.imgList = ids;

      this.$refs.reviewPhotoRef.open();
    },
    // 查询
    handleSearch() {
      this.pageInfo.page = 1;
      this.data = [];
      if (this.theUserIdentity === 'admin' || this.theUserIdentity === 'edu') {
        this.getschTeaByope();
      } else {
        this.getschTea();
      }
    },
    // 运营端请求教师考勤列表
    async getschTeaByope() {
      const obj = {
        schId: this.schoolId,
        ...this.searchData,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size
      };
      this.tableLoading = true;
      const resp = await EduCenterApi.getschTeaByope(obj);

      this.tableLoading = false;
      if (resp.status === 200) {
        this.data = resp.message.list;
        this.pageInfo.count = +resp.message.total;
        this.fixTabeleScrollX();
      }
    },
    // 教师详情
    async getschTea() {
      const params = {
        schId: this.schoolId,
        ...this.searchData,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size
      };
      console.log('params==>', params);
      this.tableLoading = true;
      const res = await this.$http.getschTea(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.data = res.message.list;
        this.pageInfo.count = +res.message.total;
        this.fixTabeleScrollX();
      } else {
        this.$Message.error(res.message);
      }
    },
    // 解决表格滚动条问题
    fixTabeleScrollX() {
      this.$nextTick(() => {
        const xDom = document.querySelector('.ivu-table-overflowX');
        if (xDom) {
          xDom.scrollLeft = xDom.scrollLeft - 50;
        }
      });
    },
    // 导出
    async exportHandel() {
      const data = {
        schId: this.schoolId,
        ...this.searchData,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size
      };
      const params = filterParams(data);
      const url = `${process.env.VUE_APP_API_COURSE_URL}/sign/export/tea`;
      downloadReport(url, params, this);
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.page = v;
      if (this.theUserIdentity === 'admin' || this.theUserIdentity === 'edu') {
        this.getschTeaByope();
      } else {
        this.getschTea();
      }
    },
    handleSizeChange(size) {
      this.pageInfo.size = size;
      this.pageInfo.page = 1;
      this.handlePageChange(1);
    },
    // 重置表单
    handleResetForm(name) {
      this.$refs[name].resetFields();
    },
    handleBtn(v, row) {
      switch (v) {
        case 'set':
          this.handleResetForm('formValidate');
          this.fillEditForm(row);
          this.modal = true;
          break;
      }
    },
    // 删除教师考勤
    async handleDelete(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          this.deleteSignTimeTea(row);
        },
        onCancel: () => {

        }
      });
    },
    async deleteSignTimeTea(row) {
      const res = await EduCenterApi.deleteSignTimeTea({
        signId: row.id,
        classroomId: row.classroomId
      });
      if (res.status == 200) {
        this.$Message.success('删除成功');
        //   this.getschTeaByope()
        this.handleSearch();
      }
    },
    // 回填
    fillEditForm(row) {
      this.signId = row.id;
      this.classroomId = row.classroomId;
      this.formValidate.teacherName = row.teacherName;
      this.formValidate.classroomName = row.classroomName;
      this.formValidate.classTimeBegin = row.classTimeBegin;
      this.formValidate.classNo = row.classNo;
      this.formValidate.signTime = row.signTime;
      this.formValidate.signoutTime = row.signoutTime;
      this.formValidate.temperature = row.temperature;
      this.formValidate.classroomId = row.classroomId;
    },

    handleMageCancel(name) {
      this.modal = false;
    },
    handleMageOK(name) {
      const istrue = /((^3[5-9])(\.\d+)?|^(4[0-5])(\.\d+)?)$/.test(
        this.formValidate.temperature
      );
      if (!this.formValidate.signTime) {
        this.$Message.error('请选择签到时间');
        return false;
      }
      // if (!this.formValidate.signoutTime) {
      //   this.$Message.error('请选择签退时间');
      //   return false;
      // }
      if (this.formValidate.temperature != '' && !istrue) {
        this.$Message.error('请输入正确的体温数');
        return false;
      }
      this.editSclTea();
    },
    setAttendance(params) {
      this.$Spin.show();
      EduCenterApi.setSignTeaResign(params).then(resp => {
        this.$Spin.hide();
        if (resp.status === 200) {
          this.$Message.success('设置成功');
          this.modal = false;
          this.getschTeaByope();
        } else {

        }
      });
    },
    // 下拉框打开
    // handleOpenChange(val) {
    //   if (val) {
    //     this.getApplyList('');
    //   }
    // },
    /* 设置签到/签退时间 */
    editSclTea() {
      const params = {
        signId: this.signId,
        classroomId: this.classroomId,
        signTime: this.formValidate.signTime,
        signoutTime: this.formValidate.signoutTime,
        temperature: this.formValidate.temperature
      };
      // if (this.theUserIdentity === 'admin') {
      this.setAttendance(params);
      // } else {
      //   this.$http.editSclTea(params).then(res => {
      //     if (res.status === 200) {
      //       // this.pageInfo.page = 1;
      //       this.modal = false;
      //       this.getschTea();
      //       this.$Message.success('设置成功');
      //     } else {
      //       this.$Message.error('设置失败');
      //     }
      //   });
      // }
    },
    // 设置签到时间
    onSettimeChange(v) {
      if (v.indexOf('00:00:00') > -1) {
        const time = getTodayDate('YYYY-MM-DD HH:mm:ss');
        this.formValidate.signTime = `${v.substring(0, 10)} ${time.substring(11)}`;
        this.formValidate = Object.assign({}, this.formValidate);
      } else {
        this.formValidate.signTime = v;
      }
    },
    // 设置签退时间
    onendSettimeChange(v) {
      // this.formValidate.signoutTime = v;

      if (v.indexOf('00:00:00') > -1) {
        const time = getTodayDate('YYYY-MM-DD HH:mm:ss');
        this.formValidate.signoutTime = `${v.substring(0, 10)} ${time.substring(11)}`;
        this.formValidate = Object.assign({}, this.formValidate);
      } else {
        this.formValidate.signoutTime = v;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.edu-home {
  min-height: 100%;
  .main {
    margin-top: 20px;
    .table_title {
      width: 100%;
      line-height: 50px;
      position: relative;
      .btn_wrap {
        position: absolute;
        top: 0;
        right: 10px;
        button {
          margin-right: 10px;
        }
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  .list {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 24px;
  }
}
.form-require {
  /deep/.ivu-form-item-label::before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}
</style>

